import { FhirBundleSdk } from "@metriport/fhir-sdk";
import type { CareGap } from "../../../../../api/care-gaps";
import { getCareGapRows } from "./care-gaps-rows";

export const metadata = {
  tableType: "CareGaps",
  displayName: "Care Gaps",
  getRows: (_bundle: FhirBundleSdk, _suspects?: unknown, careGaps?: CareGap[]) =>
    getCareGapRows({ careGaps }),
  getSearchableText: (row: Record<string, unknown>) => {
    const searchableFields = [
      "formattedMeasureName",
      "formattedStatus",
      "period",
      "formattedLastRun",
    ];

    const rowValues = searchableFields
      .map(key => String(row[key] ?? ""))
      .filter(val => val && val !== "-")
      .join(" ");

    return rowValues.toLowerCase();
  },
};
